import { DataHistory, DataModel } from '@shared/models/data-model';
import { UserGroupData } from '@/app/platform/platform-shared/models/types';

export class PlatformUserGroup extends DataModel implements Readonly<UserGroupData> {
  constructor(id: string, meta: Partial<DataHistory>, public readonly name: string) {
    super(id, meta);
  }
}
